const LttMap = () => {
    return <>
        <iframe src="https://www.google.com/maps/d/embed?mid=1WoBQH9OJfoF27P3692Q1qQr5PwMUpHs&ehbc=2E312F" width="640" height="480"></iframe>
    </>
}

export default LttMap;
